import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { dashboardZone, invitationListApi, zoneWidgets } from "../../../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setInvitationList,
  setZoneWidgets,
} from "../../../redux";
import { Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import avatar from "../../../assets/images/avatar.svg";
import {
  ModalComp,
  Profile,
  Notifs,
  Add,
  Scenario,
  Automation,
  DeviceOrg,
} from "../../../shared";
import { AutoOrSen } from "../AutoOrsen";
import { useTranslation } from "react-i18next";
import {
  FiUser,
  FiShield,
  FiHome,
  FiChevronDown,
  FiChevronUp,
  FiPlus,
  FiCpu,
  FiZap,
  FiUsers,
  FiClock,
  FiCloud,
  FiBell,
} from "react-icons/fi";

const MainPageMobileComp = (props) => {
  const { t } = useTranslation();
  const { setShowDevicsSection, showDevicsSection, today } = props;
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  const [showSecurityActivity, setShowSecurityActivity] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [openAddAutomationModal, setOpenAddAutomationModal] = useState(false);
  const [openDeviceOrgModal, setOpenDeviceOrgModal] = useState(false);
  const [isShow, setIsShow] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [profileKey, setProfileKey] = useState(0);
  let [activeIndex, setActiveIndex] = useState(0);

  const userInfo = useSelector((state) => state.userProfileInfo);
  const dispatch = useDispatch();
  const token = Cookies.get("token");

  const openDashboard = () => setShowDashboard(!showDashboard);

  const toggleProfile = () => {
    if (!openProfileModal) {
      // Generate new key when opening
      setProfileKey(Date.now());
    }
    setOpenProfileModal(!openProfileModal);
    invitationListApi(token)
      .then((res) => dispatch(setInvitationList(res.data.data)))
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const toggleNotification = () =>
    setOpenNotificationModal(!openNotificationModal);
  const toggleScenario = () => setOpenScenarioModal(!openScenarioModal);
  const toggleAddAutomation = () =>
    setOpenAddAutomationModal(!openAddAutomationModal);
  const toggleAdd = () => setOpenAddModal(!openAddModal);
  const toggleDeviceOrg = () => setOpenDeviceOrgModal(!openDeviceOrgModal);

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => dispatch(setZoneWidgets(res.data.data)))
          .catch((err) => {
            if (err.response.status === 403) {
              Cookies.remove("token");
              props.history.push("/login");
            }
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          dispatch(setZoneWidgets([]));
        }
      });
  };

  const getGreetingTime = () => {
    const h = new Date().getHours();
    if (h < 12) return t("صبح بخیر");
    if (h < 18) return t("عصر بخیر");
    return t("شب بخیر");
  };

  const getGreetingIcon = () => {
    const h = new Date().getHours();
    if (h < 12) return "🌤";
    if (h < 18) return "☀️";
    return "🌙";
  };

  const toggle = () => {
    setIsOpen((prev) => !prev);
    setShowDevicsSection(!showDevicsSection);
    if (!isOpen) {
      document.getElementById("phoneTopElements").style.height = "90vh";
    } else {
      document.getElementById("phoneTopElements").style.height = "unset";
    }
  };

  const closeScenarios = () => setIsShow(!isShow);

  return (
    <React.Fragment>
{openProfileModal && (
  <ModalComp 
    modal={openProfileModal} 
    toggle={toggleProfile} 
    component={<Profile />} 
  />
)}
      <ModalComp modal={openNotificationModal} toggle={toggleNotification} component={<Notifs />} />
      <ModalComp modal={openScenarioModal} toggle={toggleScenario} component={<Scenario />} dark={true} />
      <ModalComp modal={openAddAutomationModal} toggle={toggleAddAutomation} component={<Automation />} dark={true} />
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />
      <ModalComp modal={openDeviceOrgModal} toggle={toggleDeviceOrg} component={<DeviceOrg />} dark={true} />

      {/* Dashboard picker */}
      {showDashboard && (
        <div className="mobile-dashboard-picker">
          <div className="d-flex flex-wrap gap-2 p-3">
            {dashboardMine?.map((dash, index) => (
              <span
                key={index}
                className={`mobile-dash-chip cursor ${activeIndex === index ? "active" : ""}`}
                onClick={() => dashboardDetail(dash, index)}
              >
                {dash.dashboard_caption}
              </span>
            ))}
            <span className="mobile-dash-chip add-chip cursor" onClick={toggleAdd}>
              <FiPlus size={14} />
            </span>
          </div>
        </div>
      )}

      <div
        id="phoneTopElements"
        className="mobile-top-card"
        style={{ maxHeight: isOpen ? "90vh" : "unset", overflow: "hidden" }}
      >
        {/* ── Top Bar ── */}
        <div className="mobile-topbar">
          {/* Avatar */}
          <button className="mobile-avatar-btn" onClick={toggleProfile} aria-label="پروفایل">
            <img
              src={`https://assessn.mmaviot.com${userInfo.image}`}
              alt="avatar"
              className="mobile-avatar-img"
              onError={(e) => { e.target.src = avatar; }}
            />
            <span className="mobile-avatar-dot" />
          </button>

          {/* Greeting + date block */}
          <div className="mobile-greeting-block">
            <span className="mobile-greeting-icon">{getGreetingIcon()}</span>
            <div className="mobile-greeting-text">
              <p className="mobile-greeting-title">{getGreetingTime()}</p>
              <p className="mobile-greeting-date">{today}</p>
            </div>
          </div>

          {/* Action icons */}
          <div className="mobile-topbar-actions">
            <button
              className="mobile-security-btn"
              onClick={() => setShowSecurityActivity(!showSecurityActivity)}
              aria-label="امنیت"
              title={t("سیستم امنیتی")}
            >
              <FiShield size={18} />
            </button>
            <button
              className="mobile-icon-btn"
              onClick={toggleNotification}
              aria-label="اعلان‌ها"
            >
              <FiBell size={18} />
            </button>
            <button
              className="mobile-icon-btn"
              onClick={openDashboard}
              aria-label="داشبورد"
            >
              <FiHome size={18} />
            </button>
            <button
              className="mobile-icon-btn expand-btn"
              onClick={toggle}
              aria-label="بیشتر"
            >
              {isOpen ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
            </button>
          </div>
        </div>

        {/* ── Scrollable body ── */}
        <div className="mobile-card-body">
          {/* Scenarios strip */}
          {!isOpen && (
            <div id="scenarios" className="mobile-scenarios-strip">
              <Col className="p-0 m-0">
                {isShow && <AutoOrSen />}
              </Col>
            </div>
          )}

          {/* Add menu */}
          {isOpen && (
            <div className="mobile-add-menu">
              <p className="mobile-add-title">{t("اضافه کردن")}</p>
              <div className="mobile-add-grid">
                {[
                  { icon: <FiCpu size={20} />, label: t("دستگاه"), action: toggleDeviceOrg },
                  { icon: <FiHome size={20} />, label: t("اتاق"), action: toggleAdd },
                  { icon: <FiZap size={20} />, label: t("سناریو"), action: toggleScenario },
                  { icon: <FiClock size={20} />, label: t("اتوماسیون"), action: toggleAddAutomation },
                  { icon: <FiUser size={20} />, label: t("اعضا"), action: null },
                ].map((item, i) => (
                  <button
                    key={i}
                    className="mobile-add-item"
                    onClick={item.action || undefined}
                    aria-label={item.label}
                  >
                    <span className="mobile-add-item-icon">{item.icon}</span>
                    <span className="mobile-add-item-label">{item.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ── Bottom drag handle ── */}
        <div
          className="mobile-drag-handle cursor"
          onClick={closeScenarios}
          aria-label="بستن سناریوها"
        >
          <div className="mobile-drag-bar" />
        </div>
      </div>
    </React.Fragment>
  );
};

const MainPageMobile = withRouter(MainPageMobileComp);
export { MainPageMobile };